webpackJsonp([250029812206645],{

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Custom Properties'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When creating models, you can also define your own custom properties and methods, and use them in other methods, or invoke them directly.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate, take a look at this code:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        wordCount: function() {\n          return this.attributes.text.split(\' \').length;\n        }\n      });\n\n      const t1 = new Tweet({\n        text: \'Some old tweet\'\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we can now call ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.wordCount()'
	      ),
	      ' and it would return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '3'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-utils-custom-js-fc0e52431cfce216c1fc.js